import { CircularProgress, Backdrop as MUIBackdrop } from '@material-ui/core';
import { LoadingSpinnerIconTwoTone } from 'components';
import React from 'react';

import { useStyles } from './Backdrop.styles';

type Props = {
  isLoading?: boolean;
};
const Backdrop: React.FC<Props> = ({ isLoading = false }) => {
  const classes = useStyles();
  return (
    <MUIBackdrop className={classes.backdrop} open={isLoading}>
      {/* <CircularProgress color="inherit" /> */}
      <LoadingSpinnerIconTwoTone style={{ fontSize: '10em' }} />
    </MUIBackdrop>
  );
};

export default Backdrop;
